/** File is auto-generated by TypeWriter, a plug-in for Visual Studio. Modifications will be overridden when the template is rendered */
import { ObjectUtil } from "src/utils";
import AddressDTO from "./AddressDTO";
import InterpretingServiceDTO from "./InterpretingServiceDTO";
import LanguageProficiencyDTO from "./LanguageProficiencyDTO";
import moment from "moment";


interface AdminUserDTO {
  /** The actual ID of the user, since this is an admin only DTO */
  id: number;
  publicId: string;
  emailAddress: string;
  phoneNumber: string;
  firstName: string;
  middleName: string;
  lastName: string;
  gender: string;
  discriminator: number | null;
  twoFactorId: number | null;
  roleId: number | null;
  isApproved: boolean;
  isActive: boolean;
  dateOfBirth: moment.Moment | null;
  profilePictureUrl: string;
  currentAddress: AddressDTO | null;
  mailingAddress: AddressDTO | null;
  interpretingServices: InterpretingServiceDTO[];
  languageProficiencies: LanguageProficiencyDTO[];
}
const AdminUserDTO = {
  create: (initValues?: Partial<AdminUserDTO> | null): AdminUserDTO => {
    const defaults: AdminUserDTO = {
      id: 0,
      publicId: "",
      emailAddress: "",
      phoneNumber: "",
      firstName: "",
      middleName: "",
      lastName: "",
      gender: "",
      discriminator: null,
      twoFactorId: null,
      roleId: null,
      isApproved: false,
      isActive: false,
      dateOfBirth: null,
      profilePictureUrl: "",
      currentAddress: null,
      mailingAddress: null,
      interpretingServices: [],
      languageProficiencies: [],
    };
    const fixedValues: Partial<AdminUserDTO> = initValues != null
      ? {
        dateOfBirth: initValues.dateOfBirth != null ? ObjectUtil.ToMoment(initValues.dateOfBirth) : null,
        currentAddress: initValues.currentAddress != null ? AddressDTO.create(initValues.currentAddress) : null,
        mailingAddress: initValues.mailingAddress != null ? AddressDTO.create(initValues.mailingAddress) : null,
        interpretingServices: (initValues.interpretingServices ?? []).map(InterpretingServiceDTO.create) as InterpretingServiceDTO[],
        languageProficiencies: (initValues.languageProficiencies ?? []).map(LanguageProficiencyDTO.create) as LanguageProficiencyDTO[],
      }
      : {};
    return { ...defaults, ...initValues, ...fixedValues };
  }
};

export default AdminUserDTO;
